import { UPDATE_TRACKING_DATA } from "./trackingIdAndAnonymousLocalReducer"

export const updateTrackingData = (data) => ({
    type: UPDATE_TRACKING_DATA,
    payload: data
})